import { useState } from "react"
import { getAllergensForRecipe, getCombinedIngredients, recipeName } from "../specCardsHelpers"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faWarning } from "@fortawesome/free-solid-svg-icons"

const singular = (name) => {
      if (name.toUpperCase().slice(-1) === 'S') return name.slice(0,-1)
      return name
    }

const formattedText = (text, strongOpen, strongClose) => {
    return text.replace(/\p{L}+/gu, (letters) => `${strongOpen}${letters.toUpperCase()}${strongClose}`);
};


const buildIngredient = (ing, strongOpen, strongClose) => {

    const ingredientName = `${ing.label_name || ing.name}`

    if (!ing.allergens) return ingredientName

    let allergenArray = ing.allergens.split(',');

    const isMatch = (part) => {
    const cleanPart = part.replace(/[^a-zA-Z]/g, "");
    const match = allergenArray.find(a => singular(a).toUpperCase() === singular(cleanPart).toUpperCase())

    if (!match) return false
    allergenArray = allergenArray.filter(a => a !== match)
    return true
    }
    
    const nameParts = ingredientName.split(' ')
    const name = (nameParts.map(p => isMatch(p) ? formattedText(p, strongOpen, strongClose) : p).join(' '))

    const allergenList = allergenArray.length ? ` ${strongOpen}(${allergenArray.join(', ')})${strongClose}` : ''
    return `${name}${allergenList}`;

}

  export const buildIngredientList = (allRecipes, strongOpen, strongClose, space) => {

    const ingredients = getCombinedIngredients(allRecipes).sort((a, b) => a.quantity_adjusted < b.quantity_adjusted ? 1 : -1)

    return ingredients
      .map((ing) => {

        return buildIngredient(ing, strongOpen, strongClose)
        
      })
      .join(', '+space)
  }


  const buildLabel = (recipe, allRecipes, allergens, isHTML) => {

    const strongOpen = isHTML ? '<strong>' : ''
    const strongClose = isHTML ? '</strong>' : ''
    const newLine = isHTML ? '<br />' : '\n'
    const space = isHTML ? '&nbsp;' : ' '
    
    
    const allergenList = allergens.filter(a => a !== '!').join(', ')

    return (`${strongOpen}${recipe.label_name || recipeName(recipe)}${strongClose}${newLine}${newLine}` + buildIngredientList(allRecipes, strongOpen, strongClose, space) + `${newLine}${newLine}This product contains:${newLine}${strongOpen}${allergenList}${strongClose}${newLine}`);

  }

  export const labelForWord = (allRecipes, recipes, recipe) => {

    let allergens = getAllergensForRecipe(recipes, recipe)
    const ingredientPlain = buildLabel(recipe, allRecipes, allergens, false)

    return ingredientPlain
  }

  export const Label = ({ allRecipes, recipes, recipe }) => {


    const [copied, setCopied] = useState(false)
    
    let allergens = getAllergensForRecipe(recipes, recipe)

    const hasUnconfirmedAllergens = allergens.includes('!')

    const ingredientHtml = buildLabel(recipe, allRecipes, allergens, true)
    const ingredientPlain = buildLabel(recipe, allRecipes, allergens, false)

    const copyIngredientsToClipboard = async () => {
      const data = [
        new ClipboardItem({
          "text/html": new Blob([ingredientHtml], { type: "text/html" }),
          "text/plain": new Blob([ingredientPlain], { type: "text/plain" })
        })
      ];

      await navigator.clipboard.write(data);
      setCopied(true)
    }

    

    return (
      <div className='ingredients-label'>
        <div dangerouslySetInnerHTML={{ __html: ingredientHtml }} />
        <br/><br/>
        {hasUnconfirmedAllergens ? <div className='allergen confirm-allergen'><FontAwesomeIcon icon={faWarning} /> CONFIRM ALLERGENS</div> : ''}
        <br/><br/>
        <div className='right'><button className='inv' onClick={copyIngredientsToClipboard}>{!copied ? 'Copy to clipboard' : 'Copied!'}</button></div>
      </div>
    )
  }
